import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear, value: currentYear },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

export type CambiarPeriodoInputs = "mes" | "anio" | "razonCambioPeriodo";
export type CambiarPeriodoButtons = "aceptar" | "cancelar";

export const cambiarPeriodoFormConfig: FormBuilderConfig<
  CambiarPeriodoInputs,
  CambiarPeriodoButtons
> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 6 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "* Año",
      bts: { mCol: 6 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: aniosOpts
      }
    },
    {
      name: "razonCambioPeriodo",
      label: "Razón del Cambio",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        maxlength: 500
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      required: true
    },
    anio: {
      required: true
    },
    razonCambioPeriodo: {
      required: true,
      minLength: 1
    }
  },
  rows: [["mes", "anio"], ["razonCambioPeriodo"], ["aceptar", "cancelar"]]
};
